
import React, { useState, useEffect, createContext } from 'react'
import './coin.css'

// const Price = createContext();

function Coins(props) {

    const [tokenData, setTokenData] = useState([]);

    const getCoins = async () => {
        const url = `https://api.coingecko.com/api/v3/coins/markets?vs_currency=INR&per_page=20`;
        let data = await fetch(url);
        let parsedData = await data.json();
        // console.log(data)
        // console.log(parsedData)
        setTokenData(parsedData);
        // console.log(tokenData[0].current_price)


    }

    useEffect(() => {
        getCoins();
    }, [])

    // function to move top of the page

    // const scrollTo = () => {
    //     window.scrollTo(0, 0)
    // }
    {/* top par move krne k liye button */ }

    //      <div className="container d-flex justify-content-end">
    //      <button type="button" className="btn btn-primary" onClick={scrollTo}>Move Top</button>
    //  </div>

    return (
        <div>
            {/* <Price.Provider value={tokenData[0].current_price}> */}
            <h2 id='coin_head'>Coins List</h2>
            <div className="row">
                {tokenData.map((element) => {
                    return (
                        <>

                            <div className="card coin_card" key={element.image}>
                                <img src={element.image} className="card-img-top" alt="..." />
                                <div className="card-body">
                                    <h5 className="card-title title">{element.name}</h5>
                                    <p className="card-text coin_text">&#x20b9; {element.current_price}</p>

                                    <p className="card-text coin_text">24Low &#x20b9; {element.low_24h}</p>
                                    <p className="card-text coin_text">24High &#x20b9; {element.high_24h}</p>

                                    <p className="card-text coin_text" style={element.price_change_percentage_24h < 0 ? { color: "red" } : { color: "green" }}>24h Chg  {element.price_change_percentage_24h}%</p>

                                </div>
                            </div>



                        </>
                    )
                })}
            </div>

            {/* </Price.Provider> */}
        </div>
    )
}

export default Coins
// export { Price }